import { useEffect, useState } from "react";

const URL = `${process.env.REACT_APP_BACKEND_URL}/api/v1/subscriptions/billing-status`;
let cached = null;
let pending = null;

export const EARLY_ACCESS_LABEL = "Paid plans open soon";
export const EARLY_ACCESS_NOTE = "Paid plans open soon. The free plan stays free.";

export function loadBillingStatus() {
  if (cached) return Promise.resolve(cached);
  if (!pending) {
    pending = fetch(URL)
      .then((r) => r.json())
      .then((j) => { cached = j.data || { payments_open: false }; return cached; })
      .catch(() => ({ payments_open: false }))
      .finally(() => { pending = null; });
  }
  return pending;
}

export function usePaymentsOpen() {
  const [open, setOpen] = useState(cached ? cached.payments_open : false);
  useEffect(() => {
    let live = true;
    loadBillingStatus().then((s) => { if (live) setOpen(!!s.payments_open); });
    return () => { live = false; };
  }, []);
  return open;
}
